import type { CheckoutThunk } from "@app/modules/checkout/store/thunk-action";
import type {
  RequireCartItemAction,
  ResolveCartItemAction,
  TrackCartItemRemovalAction,
  UpdatePaymentSectionAction
} from "@app/modules/checkout/types/checkout-actions-types";
import type { Ancillary } from "@app/types/napi-v2-ancillary";

import {
  REQUIRE_CART_ITEM_ACTION,
  RESOLVE_CART_ITEM_ACTION,
  TRACK_CART_ITEM_REMOVAL
} from "../constants/action-types";

export function trackCartItemRemoval(
  cart_item_id: Ancillary["id"]
): TrackCartItemRemovalAction {
  return {
    type: TRACK_CART_ITEM_REMOVAL,
    cart_item_id
  };
}

export function requireCartItemAction(
  cart_item_id: Ancillary["id"],
  action_required: string
): CheckoutThunk<void> {
  return dispatch => {
    dispatch(_requireCartItemAction(cart_item_id, action_required));
  };
}

export function resolveCartItemAction(
  cart_item_id: Ancillary["id"]
): CheckoutThunk<void> {
  return dispatch => {
    dispatch(_resolveCartItemAction(cart_item_id));
  };
}

export function continueToPaymentInformationSectionAction(): UpdatePaymentSectionAction {
  return { type: "UPDATE_PASSENGER_SECTION", section: "payment_information" };
}

export function goBackToAddonsSectionAction(): UpdatePaymentSectionAction {
  return { type: "UPDATE_PASSENGER_SECTION", section: "travel_addons" };
}

function _requireCartItemAction(
  cart_item_id: Ancillary["id"],
  action_required: string
): RequireCartItemAction {
  return {
    type: REQUIRE_CART_ITEM_ACTION,
    cart_item_id,
    action_required
  };
}

function _resolveCartItemAction(
  cart_item_id: Ancillary["id"]
): ResolveCartItemAction {
  return {
    type: RESOLVE_CART_ITEM_ACTION,
    cart_item_id
  };
}
